export default {
    modal : state => state.modal,

    services           : state => state.services,
    servicesAppearance : state => state.servicesAppearance,
    servicesBreak      : state => state.servicesBreak,
    servicesDuration   : state => state.servicesDuration,
    servicesLoading    : state => state.servicesLoading,
}
